import DataDeletionRequest from '@/social/account/action/delete/DataDeletionRequest.vue';
import ReconnectAccounts from '../account/action/reconnect/ReconnectAccounts.vue';
import RouterView from './RouterView.vue';

export default [
  {
    path: '/social',
    component: RouterView,
    children: [
      {
        path: 'data-deletion',
        name: 'social_data_deletion',
        component: DataDeletionRequest,
      },
      {
        path: 'clients/:clientId/accounts/reconnect/:accessToken',
        component: ReconnectAccounts,
        props: true,
      },
    ],
  },
];
